import React from 'react';
import ReactDOM from 'react-dom/client';
// import './index.css';
import App from './App';
import './pages/css/stylesidbar.css';
import './pages/css/stylespage.css';
// import reportWebVitals from './reportWebVitals';
import { store } from './store/store';
import { Provider } from 'react-redux';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
